import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
const currentToken = localStorage.getItem('humblebeeAuthToken')
const initialState = {
  status: '',
  projectData: [],
  loading: false,
  error: '',
}

export const deleteProject = createAsyncThunk('deleteProject', async _id => {
  try {
    const res = await axios.delete(
      `${process.env.REACT_APP_HUMBLEBEE_API_URL}/projects/${_id}`,
      {
        headers: {
          authorization: `Bearer ${currentToken}`,
        },
      }
    )

    return res.data.project
  } catch (error) {
    return error.response.data
  }
})

const deleteProjectSlice = createSlice({
  name: 'deleteProject',
  initialState,
  reducers: {},

  extraReducers: {
    [deleteProject.pending]: (state, action) => {
      state.loading = true

      state.error = ''
    },

    [deleteProject.fulfilled]: (
      state,

      { payload, error }
    ) => {
      state.loading = false
      if (error) {
        state.error = error
      } else {
        state.projectData = payload
      }
    },

    [deleteProject.rejected]: (state, { message }) => {
      state.error = message
      state.loading = false
    },
  },
})

export default deleteProjectSlice.reducer
